import { Trans } from '@lingui/react';
import clsx from 'clsx';
import Link from 'next/link';
import type { StoreProductCollection } from 'components/productContext/types/storeProduct';

/**
 * Product type.
 * Includes loading state.
 */
export const ProductType = ({
  type,
  collections,
  className = '',
  isLoading = false,
}: {
  type: string;
  collections?: StoreProductCollection[];
  className?: string;
  isLoading?: boolean;
}) => {
  if (!type) return null;

  const collection = collections?.find(
    (collection) => collection.title === type
  );

  const Root: React.ElementType = collection ? Link : 'h2';
  const props = collection ? { href: `/collections/${collection.handle}` } : {};

  return (
    <Root className={clsx(className, isLoading && 'is-loading')} {...props}>
      {isLoading && <Trans id="accessibility.loading" message="Loading..." />}
      {!isLoading && type}
    </Root>
  );
};
